import { Nullable } from 'utils/types';
import { EMPTY_VALUE_PLACEHOLDER } from 'config/variables';
import { isNullOrUndefined } from './null-or-undefined';

const defaultOptions = {
  prefix: '',
  suffix: '',
  placeholderValue: EMPTY_VALUE_PLACEHOLDER,
};
/**
 * returns a placeholder in case values is empty|undefined|null
 */
export const placeholder = (
  value: Nullable<string | number>,
  options?: Partial<typeof defaultOptions>
): string => {
  const { placeholderValue, prefix, suffix } = {
    ...defaultOptions,
    ...options,
  };

  const formattedValue = `${prefix}${value}${suffix}`;

  return isNullOrUndefined(value) || value.toString().trim() === ''
    ? placeholderValue
    : formattedValue;
};
